import { Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import useProfily from 'hooks/useProfily';

import leiDetailApi from 'services/lei/leiDetail';
import leiZadostiApi, { ILeiPrehledZadosti } from 'services/lei/leiZadosti';

import Prehled from './formularPages/Prehled';

const UdajeGleif: React.FC = () => {
    //   const { navigateWorkaround } = useNavigateWorkaround();;
    const { lei } = useContext(Context);
    const [modalMessage, setModalMessage] = useState<string>('');
    const { setLevel } = useProfily();
    const [loading, setLoading] = useState<boolean>(false);
    const [podaneZadosti, setPodanezadosti] = useState<ILeiPrehledZadosti>();

    useEffect(() => {
        if (lei?.idVarsymZadosti?.varsym) {
            setLoading(true);
            leiZadostiApi(lei.idVarsymZadosti.varsym)
                .then(resp => {
                    setPodanezadosti(resp);
                    lei?.idVarsymZadosti?.varsym &&
                    resp.lei.filter(e => e.stav === 'ROZP' && e.typzadosti === 'REGISTRACE').length < 1
                        ? leiDetailApi(lei.idVarsymZadosti.varsym)
                              .then(responzo =>
                                  setLevel('lei', {
                                      ...lei,
                                      detailData: responzo,
                                      paymentDueDate: responzo.paymentduedate
                                  })
                              )
                              .finally(() => {
                                  setLoading(false);
                              })
                        : setLoading(false);
                })
                .catch(() => setLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadingWrapper loading={loading}>
            <Title text="LEI_MENU_GLEIF" level={3} />
            {(lei?.detailData || podaneZadosti) && (
                <Prehled
                    formData={lei?.detailData}
                    idVarsymZadosti={
                        lei?.idVarsymZadosti || {
                            id: 0,
                            varsym: '0'
                        }
                    }
                />
            )}
            <Modal
                title={<TranslateText>{'VYJADRENI_CDCP'}</TranslateText>}
                open={!!modalMessage}
                onCancel={() => setModalMessage('')}
                afterClose={() => {
                    setModalMessage('');
                }}
                footer={
                    <Row>
                        <ButtonComponent
                            id="udajeZavritBtn"
                            buttontext="ZAVRIT"
                            onClick={() => {
                                setModalMessage('');
                            }}
                        />
                    </Row>
                }
            >
                <Row>
                    <Paragraph text={modalMessage} />
                </Row>
            </Modal>
        </LoadingWrapper>
    );
};

export default UdajeGleif;
